import { Card } from "@kirvanobr/card";

import { CustomCardProps } from "./CustomCard.types";
import { styles as s } from "./CustomCard.styles";

export const CustomCard = ({ children, border = false }: CustomCardProps) => {
  return (
    <Card
      classNames={{
        base: s().base({ border }),
      }}
    >
      {children}
    </Card>
  );
};
